import { render, staticRenderFns } from "./HistoryListDefaultLayout.vue?vue&type=template&id=4b70c941&scoped=true&"
import script from "./HistoryListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./HistoryListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70c941",
  null
  
)

export default component.exports